<template>
    <div class="managingPeople hp100 bbox " v-loading="loading">

        <!-- 卡片视图 -->
        <el-card>
            <!-- 搜索-->
     <div class="messageArea">
      <span class="text">短信已使用</span><span style="margin-left:2px">:</span>
     <span class="num">{{total}}条</span>
     </div>

      <el-form :inline="true" label-width="80px" style="margin-top:20px">
        <el-form-item label="手机号">
          <el-input  clearable
          v-model="queryInfo.condition.phone" style="width:160px"></el-input>
        </el-form-item>
             <el-form-item label="发送日期">
         <el-date-picker
         value-format="yyyy-MM-dd"
      v-model="dataRange"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
        </el-form-item>
        <el-button @click="search" style="background:#F8B45B;margin-left:12px">查询</el-button>
        <el-button @click="reset" class="reset">重置</el-button>
      </el-form>
            <!-- 用户列表区域 -->
			 <div :style="{ height: height + 'px' }" >
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
                    :data="tableData"
                    border
                    fit
                    highlight-current-row
                    style="width: 100%"
                    @sort-change="sortChange"
            >
                    <el-table-column width="100px" label="类型"   prop="类型" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.type }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="140px" label="发送短信手机号"   prop="发送短信手机号" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.phone }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="发送内容"   prop="发送内容" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.message }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="70px" label="发送条数"   prop="发送条数" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.num }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="160px" label="创建时间"   prop="创建时间" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.createDt | dataFormat}}</span>
                        </template>
                    </el-table-column>
            </el-table>
			 </el-row></el-scrollbar
        >
		</div>
            <div class="footerBox">
                <!-- 分页区域 -->
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="queryInfo.currPage"
                        :page-sizes="[10, 20, 30, 50]"
                        :page-size="queryInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
  data() {
    return {
      dataRange:[],//日期
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition:{
          phone:"",
          merchantCode:localStorage.getItem('merchantCode'),

        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
    };
  },
  created() {
    // this.queryInfo.currPage=this.$route.query.currPage;
    //  this.queryInfo.pageSize=this.$route.query.pageSize;
    this.getListData();
    window.addEventListener('resize', this.getHeight)
  },
  mounted() {
    this.loading = false;
  },
  destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    //条件查询
    search(){
    if(this.dataRange==null || this.dataRange.length==0){
      this.queryInfo.condition.startDate=null
      this.queryInfo.condition.endDate=null
    }else{
     this.queryInfo.condition.startDate=this.dataRange[0]
      this.queryInfo.condition.endDate=this.dataRange[1]
    }
    this.getListData();
    },
    reset(){
      this.queryInfo.condition.phone=''
      this.$set(this,'dataRange',[])
     this.search()
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {

    },
    //跳转到详情
    gotoDetail(id) {
      var  that=this;
      this.$router.push({
        path: "/merchantSmsRecords/details",
        query: { id: id,currPage:that.queryInfo.currPage,pageSize:that.queryInfo.pageSize},
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
           var that = this;
        that.$http.post("/merchantSmsRecords/delete" ,{"id":id}).then(function (response) {
          that.$notify.success({
            title: "提示",
            message: "删除成功",
            showClose: true,
          });
          that.getListData();
        });
      }
    },
     getListData() {
        // 获取列表
      var that = this;
      that.$http.post("/merchantSmsRecords/list", that.queryInfo).then(function (response) {
        console.log(response.data.data);
        if (response.data.code == 200) {
          that.total = response.data.data.count;
          that.queryInfo.currPage=response.data.data.currPage
          that.tableData = response.data.data.data;
        }
      });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
  },
};
</script>

<style lang="less" scoped>
.messageArea{
  .text{
    color: #ACA39E;
     font-size: 18px;
  }
  .num{
    margin-left: 8px;
    color: #000000;
    font-size: 18px;
  }
}

    .textblue {
        color: #008eff;
    }
    .managingPeople {
    .el-card {
        height: calc(100vh - 114px);
        position: relative;
    .el-select > .el-input {
        width: 200px;
    }
    .header-search-box .header-search-input {
        width: 325px;
    }
    input::placeholder {
        font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
        width: 100%;
        font-size: 13px;
        background-color: transparent;
        color: #008eff;
        z-index: 102;
    }
    .footerBox {
        position: absolute;
        width: 100%;
        height: 78px;
        left: 20px;
        right: 20px;
        bottom: 0;
    }
    }
    }
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
/deep/ .el-form-item__label::after,
.pcfn::after {
  content: ":";
  position: relative;
  top: -0.5px;
  margin: 0px 0px 0px 2px;
}
/deep/ thead.has-gutter{
  height: 68px;
}
/deep/ button:hover{
  color: #606266;
  border-color:#DCDFE6;
}
/deep/ .reset:active{
    color: #606266;
  border-color:#DCDFE6;
}
/deep/ .reset:hover{
    color: #606266;
  border-color:#DCDFE6;
  background: #fff;
}
</style>

